import { createSelector } from 'reselect'

const getZoom = state => {
  return state.map.toggleZoom
}

const getZoomMin = (state, min) => {
  return min
}

export const makeZoomLevelGreaterThan = () => {
  return createSelector([getZoom, getZoomMin], (zoom, min) => {
    if (zoom && min) {
      return zoom > min
    } else {
      return null
    }
  })
}



// WEBPACK FOOTER //
// ./src/selectors/zoomLevelSelector.js